// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false
// };

//   let hostname=window.location.hostname;
//   let  url= "https://sikka.inovantsolutions.com/api/a2";
//  let imgurl= "https://sikka.inovantsolutions.com/files"
//     console.log(hostname,'hostname');
//     if(typeof window !== 'undefined'){
//       if(hostname.includes('localhost') || hostname.includes('sikka-admin.inovantsolutions.com')){
//        url= "https://sikka.inovantsolutions.com/api/a2",
//        imgurl= "https://sikka.inovantsolutions.com/files"
//       }else{
//        url= "https://playsikka.com/api/a2",
//        imgurl= "https://playsikka.com/files"
//       }
//     }
export const environment = {
production: false,
// server:url,
// imgurl:imgurl
// server: "https://sikka.inovantsolutions.com/api/a2",
// imgurl: "https://sikka.inovantsolutions.com/files"

};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
